import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    horseNameLink: {
      textTransform: "uppercase",
      color: primary.main,
      cursor: "pointer",
      position: "relative",
      zIndex: 1
    }
  };
});
